function InjectScript(src, props){
    props = props || {};
    props.attrs = props.attrs || {};
    props.onload = props.onload || function(){};
    var head = document.head;
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    Object.values(props.attrs).map((prop, key)=>{
        let name = Object.keys(props.attrs)[key];
        script.setAttribute(name, (prop ?? ""));
    })
    script.onload = function() {
        props.onload();
    }
    
    head.appendChild(script);
}

export {InjectScript}